<template>
  <v-layout align-center justify-center class="img-container" :style="styleObj">
    <v-progress-circular
      v-if="$store.getters.initialized"
      style="z-index: 20"
      :value="value"
      :rotate="-90"
      :size="130"
      :width="8"
      color="yellow"
      background-color="white"></v-progress-circular>
    <logo></logo>
  </v-layout>
</template>

<script>
import Logo from "../Logo"

export default {
  name: "CircleGraphics",
  components: { Logo },
  props: ["colors", "imgSrc", "isInside", "styleObj"],
  data() {
    return {
      interval: {},
      value: 0,
      logoClass: "",
    }
  },
  computed: {
    passedColors() {
      return this.colors
    },
  },

  methods: {
    fixCircle(colors) {
      const containers = document.getElementsByClassName("inscribe")
      for (let i = 0; i < containers.length; i++) {
        containers[i].setAttribute("style", "color: " + colors[i] + ";")
      }
    },
    onUnload() {
      this.$cookie.delete("circular-animation")
    },
  },
  mounted() {
    this.fixCircle(this.passedColors)
    window.addEventListener("beforeunload", this.onUnload)
    if (this.$cookie.get("circular-animation")) {
      this.value = 80
    } else {
      this.interval = setInterval(() => {
        if (this.value === 80) {
          return (this.value = 80)
        }
        this.value += 1
      }, 0.1)
    }
    // this.$cookie.set("circular-animation", "1", {
    //   samesite: "Lax",
    //   secure: true,
    // });
  },
  beforeDestroy() {
    clearInterval(this.interval)
    window.removeEventListener("beforeunload", this.onUnload)
  },
}
</script>

<style lang="sass" scoped>
@import '@/assets/sass/globals.sass'
.img-container
  width: 145px
  height: 145px
  border-radius: 50%

  .logo
    position: absolute
    width: 92%
    height: 92%

@media only screen and (max-width: 400px)
  .img-container
    width: 115px
    height: 115px
  .v-progress-circular
    width: 103px !important
    height: 103px !important

    .logo
      width: 95%
      height: 95%
</style>
